module.exports = __webpack_public_path__ + "img/share.b3dc8dda.jpg";